import { DeviceStore } from '../../common/types';

const DeviceInitialState: DeviceStore = {
  shadowAliases: [],
};

export default DeviceInitialState;
